import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.reports');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { workflowStatusCssClass, workflowStatusLabel } from '../shared/workflow-status';

@Component({
    selector: 'wiz-page-reports',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.reports/view.scss */
:host {
  display: block;
}

.reports-shell {
  min-height: calc(100vh - var(--ops-topbar-height));
  padding: 16px 18px 28px;
  background: var(--ops-bg);
  color: var(--ops-text);
  word-break: keep-all;
}

.reports-header,
.report-list-panel,
.report-detail-toolbar,
.report-sheet {
  border: 1px solid var(--ops-panel-border);
  border-radius: var(--ops-radius);
  background: #ffffff;
  box-shadow: var(--ops-shadow);
}

.reports-header {
  padding: 16px 18px;
}

.ops-section-kicker {
  color: var(--ops-muted-strong);
  font-size: var(--ops-type-caption);
  font-weight: 900;
  line-height: 1.2;
}

.reports-heading h1 {
  margin-top: 6px;
  color: var(--ops-heading);
  font-size: 25px;
  font-weight: 900;
  line-height: 1.24;
}

.report-list-view,
.report-detail-view {
  margin-top: 14px;
}

.report-list-panel {
  overflow: hidden;
}

.report-list-toolbar {
  display: flex;
  min-height: 56px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--ops-border);
  background: var(--ops-surface-muted);
  padding: 0 14px;
}

.report-list-toolbar div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.report-list-toolbar strong {
  color: var(--ops-heading);
  font-size: 16px;
  font-weight: 900;
}

.report-list-toolbar span {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  background: #ffffff;
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 900;
  padding: 0 9px;
}

.completed-patrol-list {
  display: grid;
}

.completed-patrol-row {
  display: grid;
  grid-template-columns: minmax(220px, 1.4fr) minmax(150px, 0.7fr) minmax(92px, 0.45fr) minmax(88px, 0.4fr) minmax(90px, 0.4fr) 22px;
  gap: 12px;
  min-height: 68px;
  align-items: center;
  border: 0;
  border-bottom: 1px solid var(--ops-border-subtle);
  background: #ffffff;
  color: var(--ops-text);
  padding: 10px 14px;
  text-align: left;
  transition: background-color 140ms ease;
}

.completed-patrol-row:last-child {
  border-bottom: 0;
}

.completed-patrol-row:hover,
.completed-patrol-row:focus-visible {
  background: var(--ops-surface-muted);
  outline: none;
}

.completed-patrol-row > span,
.completed-patrol-row > i,
.patrol-row-main span,
.patrol-row-main strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patrol-row-main {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.patrol-row-main strong {
  color: var(--ops-heading);
  font-size: 15px;
  font-weight: 900;
}

.patrol-row-main span,
.completed-patrol-row > span {
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 800;
}

.completed-patrol-row > i {
  color: var(--ops-muted);
  font-size: 12px;
  text-align: right;
}

.report-status {
  display: inline-flex;
  width: fit-content;
  min-height: 24px;
  max-width: 100%;
  align-items: center;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  background: var(--ops-neutral-soft);
  color: var(--ops-muted-strong);
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  padding: 0 9px;
  white-space: nowrap;
}

.report-status.is-done {
  border-color: var(--ops-success-border);
  background: var(--ops-success-soft);
  color: var(--ops-success);
}

.report-status.is-ready {
  border-color: var(--ops-info-border);
  background: var(--ops-info-soft);
  color: var(--ops-info);
}

.report-status.is-attention {
  border-color: var(--ops-warning-border);
  background: var(--ops-warning-soft);
  color: var(--ops-warning);
}

.report-status.is-work-patrol-setup-required,
.report-status.is-work-recapture-requested {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.report-status.is-work-patrol-scheduled {
  border-color: #d4d8d5;
  background: #f7faf8;
  color: #46534c;
}

.report-status.is-work-patrol-running {
  border-color: #bae6fd;
  background: #f0f9ff;
  color: #0369a1;
}

.report-status.is-work-patrol-completed {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #0f766e;
}

.report-status.is-work-ai-required {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.report-status.is-work-field-check-required {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.report-status.is-work-report-required {
  border-color: #a5f3fc;
  background: #ecfeff;
  color: #0e7490;
}

.report-status.is-work-report-generated {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.report-detail-toolbar {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  gap: 10px;
  align-items: center;
  padding: 10px;
}

.report-detail-title {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.report-detail-title strong,
.report-detail-title span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-detail-title strong {
  color: var(--ops-heading);
  font-size: 16px;
  font-weight: 900;
}

.report-detail-title span {
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 800;
}

.report-icon-button,
.report-primary-action,
.report-secondary-action {
  display: inline-flex;
  min-width: 0;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: var(--ops-radius-sm);
  font-size: 13px;
  font-weight: 900;
  line-height: 1.2;
  padding: 0 13px;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
  white-space: nowrap;
}

.report-icon-button,
.report-secondary-action {
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
  color: var(--ops-text);
}

.report-icon-button:hover,
.report-secondary-action:hover {
  background: var(--ops-surface-muted);
}

.report-secondary-action.is-download {
  border-color: var(--ops-primary);
  color: var(--ops-primary-dark);
}

.report-secondary-action:disabled {
  cursor: not-allowed;
  border-color: var(--ops-border);
  background: var(--ops-neutral-soft);
  color: var(--ops-muted);
}

.report-secondary-action:disabled:hover {
  background: var(--ops-neutral-soft);
}

.report-primary-action {
  border: 1px solid var(--ops-primary-dark);
  background: var(--ops-primary-dark);
  color: #ffffff;
}

.report-primary-action:hover {
  background: #0b100e;
}

.report-primary-action.is-complete,
.report-primary-action:disabled {
  cursor: default;
  border-color: var(--ops-success-border);
  background: var(--ops-success-soft);
  color: var(--ops-success);
}

.report-sheet {
  margin-top: 14px;
  padding: 22px 24px;
}

.report-sheet-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 2px solid var(--ops-primary-dark);
  padding-bottom: 16px;
}

.report-sheet-header div {
  min-width: 0;
}

.report-sheet-header p {
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 900;
}

.report-sheet-header h2 {
  margin-top: 7px;
  color: var(--ops-heading);
  font-size: 27px;
  font-weight: 900;
  line-height: 1.24;
  overflow-wrap: anywhere;
}

.report-fact-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;
}

.report-fact-grid div {
  display: grid;
  gap: 5px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 10px;
}

.report-fact-grid span {
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.report-fact-grid strong {
  color: var(--ops-heading);
  font-size: 14px;
  font-weight: 900;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.generated-report {
  display: grid;
  gap: 10px;
  margin-top: 16px;
  border: 1px solid var(--ops-success-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-success-soft);
  padding: 14px;
}

.generated-report header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.generated-report h3,
.generated-report header strong {
  color: var(--ops-success);
  font-size: 14px;
  font-weight: 900;
  line-height: 1.3;
}

.generated-report header span {
  display: block;
  margin-top: 4px;
  color: var(--ops-muted-strong);
  font-size: 11px;
  font-weight: 900;
}

.generated-report p {
  color: var(--ops-text);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.5;
}

.generated-report dl {
  display: grid;
  grid-template-columns: 1.4fr 0.8fr 0.8fr;
  gap: 8px;
  margin: 0;
}

.generated-report dl div {
  display: grid;
  min-width: 0;
  gap: 4px;
  border: 1px solid rgba(31, 122, 77, 0.18);
  border-radius: var(--ops-radius-sm);
  background: rgba(255, 255, 255, 0.58);
  padding: 8px;
}

.generated-report dt,
.generated-report dd {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.generated-report dt {
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.generated-report dd {
  margin: 0;
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
}

.report-section {
  margin-top: 18px;
}

.report-section h3 {
  border-bottom: 1px solid var(--ops-border-strong);
  color: var(--ops-heading);
  font-size: 15px;
  font-weight: 900;
  line-height: 1.3;
  padding-bottom: 8px;
}

.report-table-wrap {
  overflow-x: auto;
  margin-top: 10px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
}

.report-table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
}

.report-table th,
.report-table td {
  border-bottom: 1px solid var(--ops-border);
  border-right: 1px solid var(--ops-border);
  padding: 10px 11px;
  text-align: left;
  vertical-align: top;
}

.report-table th:last-child,
.report-table td:last-child {
  border-right: 0;
}

.report-table tr:last-child td {
  border-bottom: 0;
}

.report-table th {
  background: var(--ops-surface-strong);
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 900;
}

.report-table td {
  background: #ffffff;
  color: var(--ops-text);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
}

.report-table td strong,
.report-table td small {
  display: block;
}

.report-table td strong {
  color: var(--ops-heading);
  font-weight: 900;
}

.report-table td small {
  margin-top: 3px;
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 800;
}

.report-empty-cell {
  color: var(--ops-muted) !important;
  text-align: center !important;
}

.report-memo {
  margin-top: 10px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  color: var(--ops-text);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
  padding: 11px 12px;
}

.report-empty-state {
  display: grid;
  min-height: 320px;
  place-items: center;
  align-content: center;
  gap: 12px;
  padding: 34px 18px;
  text-align: center;
}

.report-empty-state h2 {
  color: var(--ops-heading);
  font-size: 22px;
  font-weight: 900;
  line-height: 1.25;
}

@media (max-width: 1040px) {
  .completed-patrol-row {
    grid-template-columns: minmax(180px, 1fr) minmax(130px, 0.8fr) minmax(82px, 0.45fr) minmax(82px, 0.45fr) 22px;
  }
  .completed-patrol-row > span:nth-of-type(4) {
    display: none;
  }
  .report-fact-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .generated-report dl {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 760px) {
  .reports-shell {
    padding: 12px;
  }
  .reports-heading h1,
  .report-sheet-header h2 {
    font-size: 22px;
  }
  .report-detail-toolbar,
  .completed-patrol-row {
    grid-template-columns: 1fr;
  }
  .completed-patrol-row > i {
    display: none;
  }
  .completed-patrol-row > span,
  .patrol-row-main span,
  .patrol-row-main strong,
  .report-detail-title strong,
  .report-detail-title span {
    white-space: normal;
  }
  .report-icon-button,
  .report-primary-action,
  .report-secondary-action {
    width: 100%;
  }
  .report-list-toolbar,
  .report-sheet-header {
    align-items: stretch;
    flex-direction: column;
  }
  .report-list-toolbar {
    padding: 12px;
  }
  .report-list-toolbar div,
  .report-list-toolbar button,
  .report-fact-grid {
    width: 100%;
  }
  .report-fact-grid {
    grid-template-columns: 1fr;
  }
  .report-sheet {
    padding: 18px;
  }
}`],
})
export class PageReportsComponent implements OnInit {
    public selectedPatrolCode: string = '';
    public loadMessage: string = '';

    public reports: any[] = [];
    public missionRows: any[] = [];
    public completedPatrols: any[] = [];
    public suspicionRows: any[] = [];
    public recaptureRows: any[] = [];
    public fieldCheckRows: any[] = [];
    public monthlyStats: any[] = [];

    private generatedReportMap: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.service.auth.allow('/access');
        await this.loadReports();
    }

    public async loadReports() {
        this.loadMessage = '';
        try {
            const response: any = await wiz.call('load', {}, { timeout: 15000 });
            const { code, data } = response || {};
            if (code === 200 && data) {
                this.generatedReportMap = this.savedReportMap();
                this.reports = (data.reports || []).map((item) => this.normalizeSourceItem(item));
                this.missionRows = (data.missionRows || []).map((item) => this.normalizePatrol(item));
                const completedPatrols = this.sortPatrols(
                    this.mergeCompletedPatrols(
                        (data.completedPatrols || []).map((item) => this.normalizePatrol(item)),
                        this.missionRows
                    )
                ).map((item) => this.applyReportState(item));
                this.suspicionRows = (data.suspicionRows || []).map((item) => this.normalizeSourceItem(item));
                this.recaptureRows = (data.recaptureRows || []).map((item) => this.normalizeSourceItem(item));
                this.fieldCheckRows = (data.fieldCheckRows || []).map((item) => this.normalizeSourceItem(item));
                if (completedPatrols.length) {
                    this.completedPatrols = completedPatrols;
                } else {
                    this.completedPatrols = this.sampleCompletedPatrols();
                    const supportRows = this.sampleReportSupportRows(this.completedPatrols);
                    this.suspicionRows = supportRows.suspicionRows;
                    this.recaptureRows = supportRows.recaptureRows;
                    this.fieldCheckRows = supportRows.fieldCheckRows;
                }
                this.monthlyStats = data.monthlyStats || [];
                if (!this.completedPatrols.find((item) => item.code === this.selectedPatrolCode)) {
                    this.selectedPatrolCode = '';
                }
            } else {
                this.loadMessage = (data && data.message) || '보고 데이터를 불러오지 못했습니다.';
            }
        } catch (error) {
            this.loadMessage = '보고 데이터를 불러오는 중 오류가 발생했습니다.';
        }
        await this.service.render();
    }

    public get selectedPatrol() {
        return this.completedPatrols.find((item) => item.code === this.selectedPatrolCode) || null;
    }

    public get visibleCompletedPatrols() {
        return this.completedPatrols;
    }

    public get headerMetrics() {
        const total = this.completedPatrols.length;
        const generated = this.completedPatrols.filter((item) => this.isReportGenerated(item)).length;
        const aiCount = this.completedPatrols.reduce((sum, item) => sum + Number(item.aiCaseCount || 0), 0);
        const followUp = this.completedPatrols.reduce((sum, item) => sum + Number(item.recaptureCount || 0) + Number(item.fieldCheckCount || 0), 0);
        return [
            { label: workflowStatusLabel('patrolCompleted'), value: `${total}건` },
            { label: workflowStatusLabel('reportGenerated'), value: `${generated}건` },
            { label: workflowStatusLabel('ai'), value: `${aiCount}건` },
            { label: '후속 조치', value: `${followUp}건` }
        ];
    }

    public get selectedCandidateRows() {
        return this.suspicionRows.filter((row) => this.matchesSelectedPatrol(row));
    }

    public get selectedRecaptureRows() {
        return this.recaptureRows.filter((row) => this.matchesSelectedPatrol(row));
    }

    public get selectedFieldCheckRows() {
        return this.fieldCheckRows.filter((row) => this.matchesSelectedPatrol(row));
    }

    public get selectedFollowUpRows() {
        return [
            ...this.selectedRecaptureRows.map((row) => ({ ...row, type: '재촬영' })),
            ...this.selectedFieldCheckRows.map((row) => ({ ...row, type: '현장 확인' }))
        ];
    }

    public get detailMetrics() {
        const patrol = this.selectedPatrol;
        if (!patrol) return [];
        return [
            { label: '촬영 지점', value: `${Number(patrol.pointCount || 0)}곳` },
            { label: '촬영 사진', value: `${Number(patrol.photoCount || 0)}장` },
            { label: 'AI 확인', value: `${this.selectedCandidateRows.length}건` },
            { label: '후속 조치', value: `${this.selectedFollowUpRows.length}건` }
        ];
    }

    public normalizeSourceItem(item: any) {
        const sourceType = this.sourceKey(item);
        return {
            ...(item || {}),
            sourceType: sourceType,
            sourceLabel: this.sourceLabel({ sourceType: sourceType })
        };
    }

    public normalizePatrol(item: any) {
        const sourceType = this.sourceKey(item);
        const patrol = { ...(item || {}) };
        patrol.code = patrol.code || patrol.missionCode || patrol.reportCode || '';
        patrol.missionCode = patrol.missionCode || String(patrol.code || '').replace(/^MIS-/, '');
        patrol.templateId = patrol.templateId || '';
        patrol.village = patrol.village || patrol.place || '대상 미지정';
        patrol.routeName = patrol.routeName || patrol.name || patrol.mission || '순찰 기준 미지정';
        patrol.owner = patrol.owner || patrol.operator || '담당자 미지정';
        patrol.period = patrol.period || this.monthLabel();
        patrol.pointCount = Number(patrol.pointCount || patrol.points || 0);
        patrol.photoCount = Number(patrol.photoCount || Math.max(1, patrol.pointCount) * 2);
        patrol.aiCaseCount = Number(patrol.aiCaseCount || 0);
        patrol.openAiCaseCount = Number(patrol.openAiCaseCount || 0);
        patrol.recaptureCount = Number(patrol.recaptureCount || 0);
        patrol.fieldCheckCount = Number(patrol.fieldCheckCount || 0);
        patrol.reportCode = patrol.reportCode || this.reportCodeFor(patrol);
        patrol.reportTitle = patrol.reportTitle || `${patrol.village} 순찰 결과 보고`;
        patrol.reportStatus = patrol.reportStatus || workflowStatusLabel('report');
        patrol.generatedAt = patrol.generatedAt || '';
        patrol.sourceType = sourceType;
        patrol.sourceLabel = this.sourceLabel({ sourceType: sourceType });
        return patrol;
    }

    private recentWeekdayDate(weekdayIndex: number) {
        const today = new Date();
        const currentWeekday = (today.getDay() + 6) % 7;
        const delta = (currentWeekday - weekdayIndex + 7) % 7;
        const target = new Date(today);
        target.setDate(today.getDate() - delta);
        target.setHours(0, 0, 0, 0);
        return target;
    }

    private dateLabel(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private sampleCompletedPatrols() {
        const specs: any[] = [
            { suffix: 'MON01', weekday: 0, time: '09:20:00', missionCode: 'TPL-2026-SN-01', templateId: 'ops-saneri-regular', village: '사내리', routeName: '사내리 정기 순찰', owner: '자원보전 업무팀', pointCount: 5, photoCount: 10, aiCaseCount: 1, openAiCaseCount: 0, recaptureCount: 0, fieldCheckCount: 0, reportStatus: workflowStatusLabel('reportGenerated'), generatedTime: '15:10:00' },
            { suffix: 'TUE01', weekday: 1, time: '10:05:00', missionCode: 'TPL-2026-SG-02', templateId: 'ops-samgari-lifezone', village: '삼가리 농경지', routeName: '삼가리 농경지 순찰', owner: '드론 운용 담당', pointCount: 5, photoCount: 10, aiCaseCount: 1, openAiCaseCount: 1, recaptureCount: 1, fieldCheckCount: 0, reportStatus: workflowStatusLabel('report') },
            { suffix: 'WED01', weekday: 2, time: '09:40:00', missionCode: 'TPL-2026-BJ-03', templateId: 'ops-beopjusa-entry', village: '법주사지구', routeName: '법주사지구 진입부 점검', owner: '공원관리 현장팀', pointCount: 5, photoCount: 10, aiCaseCount: 1, openAiCaseCount: 1, recaptureCount: 0, fieldCheckCount: 1, reportStatus: workflowStatusLabel('report') },
            { suffix: 'THU01', weekday: 3, time: '11:10:00', missionCode: 'TPL-2026-SN-01', templateId: 'ops-saneri-regular', village: '사내리', routeName: '사내리 정기 순찰', owner: '탐방시설 담당', pointCount: 4, photoCount: 8, aiCaseCount: 0, openAiCaseCount: 0, recaptureCount: 0, fieldCheckCount: 0, reportStatus: workflowStatusLabel('reportGenerated'), generatedTime: '14:45:00' },
            { suffix: 'FRI01', weekday: 4, time: '09:50:00', missionCode: 'TPL-2026-SG-02', templateId: 'ops-samgari-lifezone', village: '삼가리', routeName: '삼가리 농경지 순찰', owner: '드론 운용 담당', pointCount: 5, photoCount: 10, aiCaseCount: 1, openAiCaseCount: 1, recaptureCount: 0, fieldCheckCount: 0, reportStatus: workflowStatusLabel('report') },
            { suffix: 'SAT01', weekday: 5, time: '12:30:00', missionCode: 'TPL-2026-BJ-03', templateId: 'ops-beopjusa-entry', village: '법주사지구', routeName: '법주사지구 진입부 점검', owner: '공원관리 현장팀', pointCount: 5, photoCount: 10, aiCaseCount: 1, openAiCaseCount: 1, recaptureCount: 0, fieldCheckCount: 1, reportStatus: workflowStatusLabel('report') },
            { suffix: 'SUN01', weekday: 6, time: '10:45:00', missionCode: 'TPL-2026-SN-01', templateId: 'ops-saneri-regular', village: '사내리', routeName: '사내리 정기 순찰', owner: '자원보전 업무팀', pointCount: 4, photoCount: 8, aiCaseCount: 0, openAiCaseCount: 0, recaptureCount: 0, fieldCheckCount: 0, reportStatus: workflowStatusLabel('reportGenerated'), generatedTime: '13:20:00' }
        ];

        const rows = specs.map((spec) => {
            const completedDate = this.recentWeekdayDate(spec.weekday);
            const day = this.dateLabel(completedDate);
            const reportStatus = spec.reportStatus || workflowStatusLabel('report');
            const generatedAt = this.isGeneratedStatus(reportStatus) ? `${day} ${spec.generatedTime || '16:00:00'}` : '';
            return this.applyReportState(this.normalizePatrol({
                code: `MIS-${spec.missionCode}`,
                missionCode: spec.missionCode,
                templateId: spec.templateId,
                village: spec.village,
                routeName: spec.routeName,
                owner: spec.owner,
                stage: 'completed',
                status: '순찰 완료',
                completedAt: `${day} ${spec.time}`,
                completedWeekday: spec.weekday,
                period: day.slice(0, 7),
                pointCount: spec.pointCount,
                photoCount: spec.photoCount,
                aiCaseCount: spec.aiCaseCount,
                openAiCaseCount: spec.openAiCaseCount,
                recaptureCount: spec.recaptureCount,
                fieldCheckCount: spec.fieldCheckCount,
                reportCode: `RPT-${day.replace(/-/g, '')}-${spec.suffix}`,
                reportTitle: `${spec.village} 순찰 결과 보고`,
                reportStatus: reportStatus,
                generatedAt: generatedAt,
                sourceType: 'demo'
            }));
        });
        return this.sortPatrols(rows);
    }

    private isGeneratedStatus(status: string) {
        return workflowStatusLabel(status) === workflowStatusLabel('reportGenerated') || status === '생성 완료';
    }

    private sampleReportSupportRows(patrolRows: any[]) {
        const candidateProfiles: any = {
            'TPL-2026-SN-01': [
                { title: '지붕선 변화 검토', point: 'P-03 생활권 지붕선', status: workflowStatusLabel('report'), next: workflowStatusLabel('report') }
            ],
            'TPL-2026-SG-02': [
                { title: '비가림막 반사 확인', point: 'P-03 농가 비가림막', status: '재촬영 요청', next: '재촬영 요청' },
                { title: '차량 흔적 확인', point: 'P-04 진입로', status: workflowStatusLabel('ai'), next: '확인 결과 선택' }
            ],
            'TPL-2026-BJ-03': [
                { title: '법주사지구 진입부 점검', point: 'P-02 교량 하부', status: '현장 확인 필요', next: '현장 확인 필요' },
                { title: '법주사지구 진입부 점검', point: 'P-01 탐방로 하단', status: '현장 확인 필요', next: '현장 확인 필요' }
            ]
        };
        const recaptureProfiles: any = {
            'TPL-2026-SG-02': [
                { title: '비가림막 반사 확인', point: 'P-03 농가 비가림막', reason: '동일 조건 재촬영 필요', status: '재촬영 요청' }
            ]
        };
        const fieldProfiles: any = {
            'TPL-2026-BJ-03': [
                { title: '법주사지구 진입부 점검', point: 'P-02 교량 하부', reason: '현장 위치 확인 필요', status: '현장 확인 필요' },
                { title: '법주사지구 진입부 점검', point: 'P-01 탐방로 하단', reason: '철거 여부 확인 필요', status: '현장 확인 필요' }
            ]
        };

        const baseRow = (patrol: any, profile: any, index: number, category: string) => this.normalizeSourceItem({
            code: `${patrol.missionCode}-${category}-${String(index + 1).padStart(2, '0')}`,
            missionCode: patrol.missionCode,
            templateId: patrol.templateId,
            title: profile.title,
            village: patrol.village,
            point: profile.point,
            status: profile.status,
            owner: patrol.owner,
            sourceType: 'demo'
        });

        const suspicionRows: any[] = [];
        const recaptureRows: any[] = [];
        const fieldCheckRows: any[] = [];
        (patrolRows || []).forEach((patrol) => {
            (candidateProfiles[patrol.missionCode] || []).forEach((profile: any, index: number) => {
                suspicionRows.push({ ...baseRow(patrol, profile, index, 'AI'), next: profile.next || workflowStatusLabel('report') });
            });
            (recaptureProfiles[patrol.missionCode] || []).forEach((profile: any, index: number) => {
                recaptureRows.push({ ...baseRow(patrol, profile, index, 'RECAPTURE'), reason: profile.reason });
            });
            (fieldProfiles[patrol.missionCode] || []).forEach((profile: any, index: number) => {
                fieldCheckRows.push({ ...baseRow(patrol, profile, index, 'FIELD'), reason: profile.reason });
            });
        });

        return { suspicionRows, recaptureRows, fieldCheckRows };
    }

    private mergeCompletedPatrols(serverCompleted: any[], missionRows: any[]) {
        const byCode: any = {};
        (serverCompleted || []).forEach((item) => {
            if (item && item.code) byCode[item.code] = item;
        });

        const completedMap = this.completedMissionMap();
        (missionRows || []).forEach((mission) => {
            const stored = completedMap[mission.code];
            const storedCaseCount = Number(stored && stored.caseCount || 0);
            const completedByServer = mission.stage === 'completed' || mission.status === '순찰 완료';
            if (!completedByServer && (!stored || storedCaseCount <= 0)) return;

            const item = { ...mission };
            item.stage = 'completed';
            item.status = '순찰 완료';
            if (stored && stored.completedAt && !item.completedAt) item.completedAt = stored.completedAt;
            if (storedCaseCount > 0 && !item.aiCaseCount) item.aiCaseCount = storedCaseCount;
            byCode[item.code] = { ...(byCode[item.code] || {}), ...item };
        });

        return Object.keys(byCode).map((code) => byCode[code]);
    }

    private applyReportState(patrol: any) {
        const state = this.generatedReportMap[patrol.code] || this.generatedReportMap[patrol.reportCode] || null;
        if (!state) return patrol;
        return {
            ...patrol,
            reportStatus: state.reportStatus || patrol.reportStatus,
            generatedAt: state.generatedAt || patrol.generatedAt
        };
    }

    private sortPatrols(items: any[]) {
        return (items || []).slice().sort((a, b) => {
            const aTime = this.dateValue(a && (a.completedAt || a.generatedAt));
            const bTime = this.dateValue(b && (b.completedAt || b.generatedAt));
            return bTime - aTime;
        });
    }

    private matchesSelectedPatrol(row: any) {
        const patrol = this.selectedPatrol;
        if (!patrol || !row) return false;
        const rowMissionCode = String(row.missionCode || '').trim();
        const rowTemplateId = String(row.templateId || '').trim();
        const rowVillage = String(row.village || '').trim();
        if (patrol.missionCode && rowMissionCode && rowMissionCode === patrol.missionCode) return true;
        if (patrol.templateId && rowTemplateId && rowTemplateId === patrol.templateId) return true;
        return !!(patrol.village && rowVillage && rowVillage === patrol.village);
    }

    private sourceKey(item: any) {
        const value = (item && (item.sourceType || item.scenarioType) || '').toString().toLowerCase();
        if (value === 'demo' || value === 'sample' || value === 'example' || value === 'default') return 'demo';
        if (value === 'mixed' || value === 'both') return 'mixed';
        return 'custom';
    }

    public sourceLabel(item: any) {
        const value = this.sourceKey(item);
        if (value === 'demo') return '운영 기준';
        if (value === 'mixed') return '운영/등록 기준';
        return '등록 기준';
    }

    public async openPatrol(code: string) {
        this.selectedPatrolCode = code;
        await this.service.render();
    }

    public async backToList() {
        this.selectedPatrolCode = '';
        await this.service.render();
    }

    public goMissions() {
        this.service.href('/missions');
    }

    public async generateReport() {
        const patrol = this.selectedPatrol;
        if (!patrol || this.isReportGenerated(patrol)) return;
        this.markReportGenerated(patrol);
        await this.service.render();
    }

    public async downloadHwpxReport() {
        const patrol = this.selectedPatrol;
        if (!patrol) return;
        try {
            if (!this.isReportGenerated(patrol)) {
                this.loadMessage = '보고서 생성 완료 후 HWPX 다운로드가 가능합니다.';
                await this.service.render();
                return;
            }
            const report = this.buildHwpxReportPackage(patrol);
            const archive = this.createStoredZip(report.files);
            this.downloadBytes(archive, report.fileName, 'application/hwp+zip');
            this.loadMessage = '';
        } catch (error) {
            this.loadMessage = 'HWPX 보고서를 생성하지 못했습니다. 잠시 후 다시 시도해주세요.';
        }
        await this.service.render();
    }

    public isReportGenerated(patrol: any) {
        return !!patrol && (workflowStatusLabel(patrol.reportStatus) === workflowStatusLabel('reportGenerated') || patrol.reportStatus === '생성 완료' || !!patrol.generatedAt);
    }

    public reportStatusLabel(patrol: any) {
        return workflowStatusLabel(this.reportWorkflowStatusKey(patrol));
    }

    public reportStatusClass(patrol: any) {
        return workflowStatusCssClass(this.reportWorkflowStatusKey(patrol));
    }

    private reportWorkflowStatusKey(patrol: any) {
        if (!patrol) return 'report';
        if (this.isReportGenerated(patrol)) return 'reportGenerated';
        if (Number(patrol.fieldCheckCount || 0) > 0) return 'field';
        if (Number(patrol.recaptureCount || 0) > 0) return 'recapture';
        if (Number(patrol.openAiCaseCount || 0) > 0) return 'ai';
        return 'report';
    }

    public generateButtonLabel(patrol: any) {
        return this.isReportGenerated(patrol) ? workflowStatusLabel('reportGenerated') : '보고서 생성';
    }

    public downloadButtonLabel(patrol: any) {
        return this.isReportGenerated(patrol) ? 'HWPX 다운로드 가능' : 'HWPX 다운로드 대기';
    }

    public generatedReportLead(patrol: any) {
        if (!patrol) return '';
        return `${patrol.village} 순찰 촬영자료 ${Number(patrol.photoCount || 0)}장에 AI 확인 결과 ${this.selectedCandidateRows.length}건과 후속 조치 ${this.selectedFollowUpRows.length}건을 반영해 보고서를 생성했습니다.`;
    }

    public candidateTitle(row: any) {
        return this.cleanReportText(row && (row.title || row.candidateArea), 'AI 확인 대상');
    }

    public candidateStatus(row: any) {
        return this.cleanReportText(row && row.status, workflowStatusLabel('ai'));
    }

    public followUpReason(row: any) {
        return this.cleanReportText(row && row.reason, '후속 조치 반영');
    }

    public cleanReportText(value: any, fallback: string = '') {
        const text = this.sanitizeScoreText(String(value || fallback).trim() || fallback);
        return text
            .replace(/AI\s*후\s*보/g, 'AI 확인 대상')
            .replace(/변화\s*후\s*보/g, '변화 의심')
            .replace(/후\s*보\s*영역/g, '확인 위치')
            .replace(/확인\s*후\s*보/g, '확인 대상')
            .replace(/후\s*보\s*생성/g, '확인 대상 반영')
            .replace(/후\s*보/g, '확인 대상')
            .replace(/오탐 처리/g, '이상 없음 종결')
            .replace(/오탐/g, '이상 없음 종결')
            .replace(/변화 아님/g, '이상 없음 종결')
            .replace(/현장 확인 요청/g, '현장 확인 필요')
            .replace(/^현장 확인$/g, '현장 확인 필요')
            .replace(/^재촬영$/g, '재촬영 요청')
            .replace(/검토 대기/g, workflowStatusLabel('ai'))
            .replace(/확인 대기/g, workflowStatusLabel('ai'))
            .replace(/담당자 확인 필요/g, workflowStatusLabel('ai'))
            .replace(/보고 반영/g, workflowStatusLabel('report'))
            .replace(/처리 완료/g, workflowStatusLabel('report'))
            .replace(/이상 없음 종결/g, workflowStatusLabel('report'))
            .replace(/^종결$/g, workflowStatusLabel('report'))
            .replace(/판정/g, '확인 결과');
    }

    private sanitizeScoreText(text: string) {
        return String(text || '')
            .replace(/AI\s*참고\s*[:：]?\s*\d+\s*%?/gi, '확인 참고')
            .replace(/(위험도|신뢰도|점수)\s*[:：]?\s*\d+\s*%?/g, '')
            .replace(/\d+\s*점/g, '')
            .replace(/\d+\s*%/g, '')
            .replace(/\s*[·,/|-]\s*(?=\s*[·,/|-]|$)/g, ' ')
            .replace(/\s{2,}/g, ' ')
            .trim();
    }

    public reportSummary(patrol: any) {
        if (!patrol) return '';
        return `${patrol.village} ${patrol.routeName} 촬영 ${Number(patrol.photoCount || 0)}장 완료. AI 확인 ${this.selectedCandidateRows.length}건, 후속 조치 ${this.selectedFollowUpRows.length}건.`;
    }

    public ownerMemo(patrol: any) {
        if (!patrol) return '';
        if (!this.selectedCandidateRows.length) return `${patrol.owner} · AI 확인 대상 없음 · 순찰 결과 보관`;
        const recaptureText = this.selectedRecaptureRows.length ? `재촬영 ${this.selectedRecaptureRows.length}건` : '재촬영 없음';
        const fieldText = this.selectedFieldCheckRows.length ? `현장 확인 ${this.selectedFieldCheckRows.length}건` : '현장 확인 없음';
        return `${patrol.owner} · ${recaptureText} · ${fieldText}`;
    }

    public formatDateTime(value: any) {
        const text = String(value || '').trim();
        if (!text) return '기록 없음';
        const date = new Date(text);
        if (isNaN(date.getTime())) return text;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
        return `${year}-${month}-${day}(${weekdays[date.getDay()]}) ${hour}:${minute}`;
    }

    public todayLabel() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    public monthLabel() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    }

    public nowLabel() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hour = String(now.getHours()).padStart(2, '0');
        const minute = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}`;
    }

    private markReportGenerated(patrol: any) {
        patrol.reportStatus = workflowStatusLabel('reportGenerated');
        if (!patrol.generatedAt) patrol.generatedAt = this.nowLabel();
        this.rememberReport(patrol);
    }

    private buildHwpxReportPackage(patrol: any) {
        const reportTitle = `${patrol.village} AI 순찰 결과 보고서`;
        const fileName = this.safeFileName(`${patrol.reportCode}_${patrol.village}_AI순찰결과보고서.hwpx`);
        const previewText = this.buildHwpxPreviewText(patrol);
        return {
            fileName: fileName,
            files: [
                { path: 'mimetype', content: 'application/hwp+zip' },
                { path: 'version.xml', content: this.buildHwpxVersionXml() },
                { path: 'settings.xml', content: this.buildHwpxSettingsXml() },
                { path: 'META-INF/container.xml', content: this.buildHwpxContainerXml() },
                { path: 'META-INF/manifest.xml', content: this.buildHwpxManifestXml() },
                { path: 'Contents/content.hpf', content: this.buildHwpxContentHpf(patrol, reportTitle) },
                { path: 'Contents/header.xml', content: this.buildHwpxHeaderXml() },
                { path: 'Contents/section0.xml', content: this.buildHwpxSectionXml(patrol, reportTitle) },
                { path: 'Preview/PrvText.txt', content: previewText }
            ]
        };
    }

    private parkAgencyName() {
        return '국립공원공단';
    }

    private parkOfficeName() {
        return '속리산국립공원사무소';
    }

    private parkReportOrgName() {
        return `${this.parkAgencyName()} ${this.parkOfficeName()}`;
    }

    private reportDocumentType() {
        return 'AI 순찰 결과 보고';
    }

    private reportManagementClass(patrol: any) {
        const route = String(patrol && patrol.routeName || '');
        if (route.indexOf('생활권') >= 0 || route.indexOf('농경지') >= 0) return '생활권 인접 자원관리';
        if (route.indexOf('진입') >= 0 || route.indexOf('시설') >= 0) return '탐방시설·진입부 관리';
        return '자연자원 변화 모니터링';
    }

    private reportWorkState(aiRows: any[], followRows: any[], patrol: any) {
        const openAiCount = Number(patrol && patrol.openAiCaseCount || 0);
        const hasFieldCheck = followRows.some((row) => String(row && row.type || '').indexOf('현장') >= 0);
        const hasRecapture = followRows.some((row) => String(row && row.type || '').indexOf('재촬영') >= 0);
        if (hasFieldCheck) return workflowStatusLabel('field');
        if (hasRecapture) return workflowStatusLabel('recapture');
        if (followRows.length || openAiCount) return workflowStatusLabel('ai');
        return workflowStatusLabel('report');
    }

    private reportActionDirection(workState: string, followRows: any[]) {
        if (workState === workflowStatusLabel('field')) return '현장 확인 필요 항목을 우선 배정하고 후속 조치 이력에 반영';
        if (workState === workflowStatusLabel('recapture')) return '재촬영 요청 항목은 동일 조건 촬영 결과를 후속 조치 이력에 반영';
        if (workState === workflowStatusLabel('ai')) return '담당자가 대상 사진을 확인한 뒤 필요한 조치를 선택';
        if (workState === workflowStatusLabel('report')) return 'AI 확인 결과를 보고서와 순찰 이력에 반영하고 동일 지점 변화 추이를 다음 순찰에서 비교';
        return '정기 순찰 주기를 유지하고 원본 촬영자료를 보존';
    }

    private reportDistributionText(patrol: any) {
        const owner = patrol && patrol.owner ? patrol.owner : '자원보전 업무팀';
        return `${owner}, 드론 운용 담당, 현장 관리 담당 공유 / 순찰 원본 및 AI 확인 기록과 함께 보관`;
    }

    private buildHwpxPreviewText(patrol: any) {
        const aiRows = this.selectedCandidateRows;
        const followRows = this.selectedFollowUpRows;
        const workState = this.reportWorkState(aiRows, followRows, patrol);
        return [
            this.parkReportOrgName(),
            '속리산국립공원 AI 순찰 결과 보고서',
            `문서번호: ${patrol.reportCode}`,
            `보고유형: ${this.reportDocumentType()}`,
            `대상구역: ${patrol.village}`,
            `순찰명: ${patrol.routeName}`,
            `관리분류: ${this.reportManagementClass(patrol)}`,
            `업무상태: ${workState}`,
            `완료일시: ${this.formatDateTime(patrol.completedAt)}`,
            `작성부서: ${patrol.owner}`,
            `촬영자료: ${Number(patrol.photoCount || 0)}장 / ${Number(patrol.pointCount || 0)}개 지점`,
            `AI 확인: ${aiRows.length}건`,
            `후속 조치: ${followRows.length}건`,
            '',
            this.generatedReportLead(patrol),
            this.reportActionDirection(workState, followRows),
            '',
            'AI 확인 결과',
            ...(aiRows.length ? aiRows.map((row, index) => `${index + 1}. ${this.candidateTitle(row)} / ${row.point || row.village} / ${this.candidateStatus(row)}`) : ['확인 대상 없음']),
            '',
            '후속 조치 계획',
            ...(followRows.length ? followRows.map((row, index) => `${index + 1}. ${row.type} / ${this.candidateTitle(row)} / ${this.followUpReason(row)}`) : ['후속 조치 없음'])
        ].join('\n');
    }

    private buildHwpxSectionXml(patrol: any, reportTitle: string) {
        const state = { paragraphId: 1000000001, tableId: 1000000901 };
        const aiRows = this.selectedCandidateRows;
        const followRows = this.selectedFollowUpRows;
        const agency = this.parkAgencyName();
        const office = this.parkOfficeName();
        const orgName = this.parkReportOrgName();
        const documentType = this.reportDocumentType();
        const managementClass = this.reportManagementClass(patrol);
        const workState = this.reportWorkState(aiRows, followRows, patrol);
        const actionDirection = this.reportActionDirection(workState, followRows);
        const distributionText = this.reportDistributionText(patrol);
        const followUpText = followRows.length ? `${followRows.length}건 후속 조치 반영` : '후속 조치 없음';
        const openAiText = Number(patrol.openAiCaseCount || 0) > 0 ? `${Number(patrol.openAiCaseCount || 0)}건 ${workflowStatusLabel('ai')}` : workflowStatusLabel('report');
        const summaryRows = [
            [{ text: '보고기관', header: true }, orgName, { text: '문서번호', header: true }, patrol.reportCode],
            [{ text: '보고유형', header: true }, documentType, { text: '업무상태', header: true }, workState],
            [{ text: '대상구역', header: true }, `${patrol.village} / ${patrol.routeName}`, { text: '관리분류', header: true }, managementClass],
            [{ text: '순찰완료', header: true }, this.formatDateTime(patrol.completedAt), { text: '작성일시', header: true }, patrol.generatedAt || this.nowLabel()],
            [{ text: '촬영자료', header: true }, `${Number(patrol.photoCount || 0)}장 / ${Number(patrol.pointCount || 0)}개 지점`, { text: '작성부서', header: true }, patrol.owner]
        ];
        const approvalRows = [
            [{ text: '작성', header: true }, patrol.owner, { text: '검토', header: true }, '자원보전 담당', { text: '확인', header: true }, office],
            [{ text: '일자', header: true }, patrol.generatedAt || this.nowLabel(), { text: '의견', header: true }, workflowStatusLabel('report'), { text: '상태', header: true }, this.reportStatusLabel(patrol)]
        ];
        const executiveRows = [
            [{ text: '핵심 결론', header: true }, this.generatedReportLead(patrol)],
            [{ text: '업무 상태', header: true }, `${workState} / ${followUpText}`],
            [{ text: '조치 방향', header: true }, actionDirection],
            [{ text: '배포·보관', header: true }, distributionText]
        ];
        const overviewRows = [
            [{ text: '보고 목적', header: true }, `${office} ${managementClass} 업무에 따라 ${patrol.village} 순찰 완료 자료와 AI 확인 결과를 통합 보고함`],
            [{ text: '운영 결과', header: true }, `${patrol.routeName} 기준으로 ${Number(patrol.pointCount || 0)}개 지점 촬영 및 ${Number(patrol.photoCount || 0)}장 자료 확보`],
            [{ text: 'AI 확인', header: true }, `AI 확인 결과 ${aiRows.length}건 반영 / ${openAiText}`],
            [{ text: '후속 조치', header: true }, followUpText],
            [{ text: '기록 관리', header: true }, '순찰 원본, AI 확인 결과, 후속 조치 이력을 동일 문서번호로 보관']
        ];
        const aiTableRows = aiRows.length ? [
            [{ text: '구분', header: true }, { text: '확인 내용', header: true }, { text: '위치', header: true }, { text: '상태', header: true }, { text: '조치', header: true }],
            ...aiRows.map((row, index) => [
                `AI-${index + 1}`,
                this.candidateTitle(row),
                row.point || row.village || patrol.village,
                this.candidateStatus(row),
                this.cleanReportText(row.next, workflowStatusLabel('report'))
            ])
        ] : [
            [{ text: '구분', header: true }, { text: '확인 내용', header: true }, { text: '위치', header: true }, { text: '상태', header: true }, { text: '조치', header: true }],
            ['-', '확인 대상 없음', patrol.village, workflowStatusLabel('report'), '결과 보관']
        ];
        const followTableRows = followRows.length ? [
            [{ text: '구분', header: true }, { text: '대상', header: true }, { text: '사유', header: true }, { text: '담당', header: true }],
            ...followRows.map((row) => [
                row.type,
                `${this.candidateTitle(row)} (${row.point || row.village || patrol.village})`,
                this.followUpReason(row),
                row.owner || patrol.owner
            ])
        ] : [
            [{ text: '구분', header: true }, { text: '대상', header: true }, { text: '사유', header: true }, { text: '담당', header: true }],
            ['-', '해당 없음', '추가 조치 필요 항목 없음', patrol.owner]
        ];
        const managementRows = [
            [{ text: '항목', header: true }, { text: '상태', header: true }, { text: '조치 기준', header: true }],
            ['순찰 완료성', '완료', `${Number(patrol.pointCount || 0)}개 지점 촬영자료를 보고 근거로 편성`],
            ['AI 확인 항목', openAiText, aiRows.length ? 'AI 확인 결과를 순찰 이력에 반영하고 동일 지점 비교 관찰' : '특이 변화 없음으로 기록 보관'],
            ['후속 조치', followUpText, actionDirection],
            ['공유 범위', '내부 공유', distributionText]
        ];
        const body = [
            this.hwpxSectionSettingsParagraph(state),
            this.hwpxParagraph(state, orgName, '5', '1'),
            this.hwpxParagraph(state, '속리산국립공원 AI 순찰 결과 보고서', '1', '2'),
            this.hwpxParagraph(state, reportTitle, '2', '1'),
            this.hwpxParagraph(state, `${agency} ${office} · ${documentType} · 문서번호 ${patrol.reportCode}`, '5', '1'),
            this.hwpxParagraph(state, ''),
            this.hwpxTableParagraph(state, summaryRows, [7800, 13460, 7800, 13460]),
            this.hwpxTableParagraph(state, approvalRows, [5200, 8900, 5200, 8900, 5200, 9120]),
            this.hwpxParagraph(state, ''),
            this.hwpxParagraph(state, '제1장 핵심 보고', '7', '7', 42520, true),
            this.hwpxTableParagraph(state, executiveRows, [9000, 33520]),
            this.hwpxParagraph(state, '제2장 순찰 개요 및 확인 상태', '7', '7', 42520, true),
            this.hwpxParagraph(state, '2.1 순찰 개요', '3', '3'),
            this.hwpxTableParagraph(state, overviewRows, [9000, 33520]),
            this.hwpxParagraph(state, '2.2 확인 상태 및 조치 방향', '3', '3'),
            this.hwpxParagraph(state, `□ ${patrol.village} 순찰은 ${this.formatDateTime(patrol.completedAt)} 완료되었으며, 확보된 촬영자료 ${Number(patrol.photoCount || 0)}장을 보고 자료로 편성함.`, '0', '4'),
            this.hwpxParagraph(state, `□ 업무 상태는 ${workState}이며, AI 확인 결과 ${aiRows.length}건 중 후속 조치 대상은 ${followRows.length}건으로 정리함.`, followRows.length ? '6' : '0', '4'),
            this.hwpxParagraph(state, `□ 담당 메모: ${this.ownerMemo(patrol)}`, '0', '4'),
            this.hwpxTableParagraph(state, managementRows, [7600, 9800, 25120]),
            this.hwpxParagraph(state, '제3장 AI 확인 및 후속 조치', '7', '7', 42520, true),
            this.hwpxParagraph(state, '3.1 AI 확인 결과', '3', '3'),
            this.hwpxTableParagraph(state, aiTableRows, [5200, 13500, 8500, 7200, 8120]),
            this.hwpxParagraph(state, '3.2 후속 조치 계획', '3', '3'),
            this.hwpxTableParagraph(state, followTableRows, [6500, 14000, 14020, 8000]),
            this.hwpxParagraph(state, '제4장 보고 처리 및 보관', '7', '7', 42520, true),
            this.hwpxParagraph(state, `□ 본 보고서는 ${office} ${patrol.owner}에서 검토 후 내부 공유 및 후속 조치 이력 관리에 사용함.`, '0', '4'),
            this.hwpxParagraph(state, '□ AI 확인 자료는 순찰 원본 사진과 함께 보관하며, 필요 시 현장 재확인 결과를 본 보고서에 추가 반영함.', '0', '4'),
            this.hwpxParagraph(state, ''),
            this.hwpxParagraph(state, `※ 본 문서는 ${orgName} ${documentType} 문서로, 완료 순찰 데이터와 AI 확인 결과 및 후속 조치 항목을 반영해 생성되었습니다.`, '5', '0')
        ];

        return `<?xml version="1.0" encoding="UTF-8"?>\n<hs:sec ${this.hwpxNamespaces()}>\n${body.join('\n')}\n</hs:sec>`;
    }

    private hwpxSectionSettingsParagraph(state: any) {
        const id = this.nextHwpxId(state);
        return `  <hp:p id="${id}" paraPrIDRef="0" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
    <hp:run charPrIDRef="0">
      <hp:secPr id="" textDirection="HORIZONTAL" spaceColumns="1134" tabStop="8000" tabStopVal="4000" tabStopUnit="HWPUNIT" outlineShapeIDRef="1" memoShapeIDRef="0" textVerticalWidthHead="0" masterPageCnt="0">
        <hp:grid lineGrid="0" charGrid="0" wonggojiFormat="0"/>
        <hp:startNum pageStartsOn="BOTH" page="0" pic="0" tbl="0" equation="0"/>
        <hp:visibility hideFirstHeader="0" hideFirstFooter="0" hideFirstMasterPage="0" border="SHOW_ALL" fill="SHOW_ALL" hideFirstPageNum="0" hideFirstEmptyLine="0" showLineNumber="0"/>
        <hp:lineNumberShape restartType="0" countBy="0" distance="0" startNumber="0"/>
        <hp:pagePr landscape="WIDELY" width="59528" height="84186" gutterType="LEFT_ONLY">
          <hp:margin header="4252" footer="4252" gutter="0" left="8504" right="8504" top="5668" bottom="4252"/>
        </hp:pagePr>
        <hp:footNotePr>
          <hp:autoNumFormat type="DIGIT" userChar="" prefixChar="" suffixChar=")" supscript="0"/>
          <hp:noteLine length="-1" type="SOLID" width="0.12 mm" color="#000000"/>
          <hp:noteSpacing betweenNotes="283" belowLine="567" aboveLine="850"/>
          <hp:numbering type="CONTINUOUS" newNum="1"/>
          <hp:placement place="EACH_COLUMN" beneathText="0"/>
        </hp:footNotePr>
        <hp:endNotePr>
          <hp:autoNumFormat type="DIGIT" userChar="" prefixChar="" suffixChar=")" supscript="0"/>
          <hp:noteLine length="14692344" type="SOLID" width="0.12 mm" color="#000000"/>
          <hp:noteSpacing betweenNotes="0" belowLine="567" aboveLine="850"/>
          <hp:numbering type="CONTINUOUS" newNum="1"/>
          <hp:placement place="END_OF_DOCUMENT" beneathText="0"/>
        </hp:endNotePr>
        <hp:pageBorderFill type="BOTH" borderFillIDRef="1" textBorder="PAPER" headerInside="0" footerInside="0" fillArea="PAPER">
          <hp:offset left="1417" right="1417" top="1417" bottom="1417"/>
        </hp:pageBorderFill>
      </hp:secPr>
      <hp:ctrl>
        <hp:colPr id="" type="NEWSPAPER" layout="LEFT" colCount="1" sameSz="1" sameGap="0"/>
      </hp:ctrl>
    </hp:run>
    <hp:run charPrIDRef="0"><hp:t/></hp:run>
    ${this.hwpxLineSeg(1000, 42520)}
  </hp:p>`;
    }

    private hwpxParagraph(state: any, text: any, charPr: string = '0', paraPr: string = '0', horzSize: number = 42520, pageBreak: boolean = false) {
        const height = this.hwpxTextHeight(charPr);
        const content = this.xmlText(text);
        const textNode = content ? `<hp:t>${content}</hp:t>` : '<hp:t/>';
        return `  <hp:p id="${this.nextHwpxId(state)}" paraPrIDRef="${paraPr}" styleIDRef="0" pageBreak="${pageBreak ? 1 : 0}" columnBreak="0" merged="0">
    <hp:run charPrIDRef="${charPr}">${textNode}</hp:run>
    ${this.hwpxLineSeg(height, horzSize)}
  </hp:p>`;
    }

    private hwpxTableParagraph(state: any, rows: any[][], colWidths: number[]) {
        const tableId = state.tableId++;
        const rowHeights = rows.map((row) => this.hwpxTableRowHeight(row));
        const tableHeight = rowHeights.reduce((sum, height) => sum + height, 0);
        const tableRows = rows.map((row, rowIndex) => {
            const rowHeight = rowHeights[rowIndex];
            const cells = colWidths.map((width, colIndex) => {
                const cell = this.normalizeHwpxCell(row[colIndex]);
                const borderFill = cell.header ? 4 : 3;
                const paraPr = cell.center || cell.header ? '5' : '6';
                const charPr = cell.header ? '4' : '0';
                const textWidth = Math.max(1, width - 1320);
                return `        <hp:tc name="" header="${cell.header ? 1 : 0}" hasMargin="0" protect="0" editable="0" dirty="1" borderFillIDRef="${borderFill}">
          <hp:subList id="" textDirection="HORIZONTAL" lineWrap="BREAK" vertAlign="CENTER" linkListIDRef="0" linkListNextIDRef="0" textWidth="0" textHeight="0" hasTextRef="0" hasNumRef="0">
${this.hwpxParagraph(state, cell.text, charPr, paraPr, textWidth)}
          </hp:subList>
          <hp:cellAddr colAddr="${colIndex}" rowAddr="${rowIndex}"/>
          <hp:cellSpan colSpan="1" rowSpan="1"/>
          <hp:cellSz width="${width}" height="${rowHeight}"/>
          <hp:cellMargin left="660" right="660" top="220" bottom="220"/>
        </hp:tc>`;
            }).join('\n');
            return `      <hp:tr>\n${cells}\n      </hp:tr>`;
        }).join('\n');

        return `  <hp:p id="${this.nextHwpxId(state)}" paraPrIDRef="0" styleIDRef="0" pageBreak="0" columnBreak="0" merged="0">
    <hp:run charPrIDRef="0">
      <hp:tbl id="${tableId}" zOrder="0" numberingType="TABLE" textWrap="TOP_AND_BOTTOM" textFlow="BOTH_SIDES" lock="0" dropcapstyle="None" pageBreak="CELL" repeatHeader="1" rowCnt="${rows.length}" colCnt="${colWidths.length}" cellSpacing="0" borderFillIDRef="3" noAdjust="0">
        <hp:sz width="42520" widthRelTo="ABSOLUTE" height="${tableHeight}" heightRelTo="ABSOLUTE" protect="0"/>
        <hp:pos treatAsChar="1" affectLSpacing="0" flowWithText="1" allowOverlap="0" holdAnchorAndSO="0" vertRelTo="PARA" horzRelTo="COLUMN" vertAlign="TOP" horzAlign="LEFT" vertOffset="0" horzOffset="0"/>
        <hp:outMargin left="0" right="0" top="0" bottom="0"/>
        <hp:inMargin left="0" right="0" top="0" bottom="0"/>
${tableRows}
      </hp:tbl>
    </hp:run>
    ${this.hwpxLineSeg(1000, 42520)}
  </hp:p>`;
    }

    private hwpxTableRowHeight(row: any[]) {
        const cells = (row || []).map((cell) => this.normalizeHwpxCell(cell));
        const isHeaderRow = cells.length > 0 && cells.every((cell) => cell.header);
        if (isHeaderRow) return 2700;
        const maxLength = cells.reduce((max, cell) => Math.max(max, String(cell.text || '').length), 0);
        const extraLines = Math.max(0, Math.ceil(maxLength / 32) - 1);
        return Math.min(6200, 3000 + extraLines * 720);
    }

    private normalizeHwpxCell(value: any) {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            return {
                text: value.text || '',
                header: !!value.header,
                center: !!value.center
            };
        }
        return { text: value || '', header: false, center: false };
    }

    private hwpxLineSeg(height: number, horzSize: number) {
        const baseline = Math.round(height * 0.85);
        const spacing = Math.round(height * 0.6);
        return `<hp:linesegarray><hp:lineseg textpos="0" vertpos="0" vertsize="${height}" textheight="${height}" baseline="${baseline}" spacing="${spacing}" horzpos="0" horzsize="${horzSize}" flags="393216"/></hp:linesegarray>`;
    }

    private hwpxTextHeight(charPr: string) {
        if (charPr === '1') return 2200;
        if (charPr === '7') return 1500;
        if (charPr === '2' || charPr === '3') return 1300;
        if (charPr === '5') return 900;
        return 1000;
    }

    private nextHwpxId(state: any) {
        const id = state.paragraphId;
        state.paragraphId += 1;
        return id;
    }

    private buildHwpxHeaderXml() {
        return `<?xml version="1.0" encoding="UTF-8"?>
<hh:head ${this.hwpxNamespaces()} version="1.5" secCnt="1">
  <hh:beginNum page="1" footnote="1" endnote="1" pic="1" tbl="1" equation="1"/>
  <hh:refList>
    ${this.hwpxFontFaces()}
    <hh:borderFills itemCnt="4">
      ${this.hwpxBorderFill(1, 'NONE', 'none')}
      ${this.hwpxBorderFill(2, 'NONE', 'none')}
      ${this.hwpxBorderFill(3, 'SOLID', 'none')}
      ${this.hwpxBorderFill(4, 'SOLID', '#E8F4ED')}
    </hh:borderFills>
    <hh:charProperties itemCnt="8">
      ${this.hwpxCharPr(0, 1000, '#111827', 1, false, -1)}
      ${this.hwpxCharPr(1, 2200, '#003E7E', 0, true, -4)}
      ${this.hwpxCharPr(2, 1300, '#174E36', 0, true, -2)}
      ${this.hwpxCharPr(3, 1300, '#0B6B45', 0, true, -1)}
      ${this.hwpxCharPr(4, 1000, '#0E2B20', 0, true, -1)}
      ${this.hwpxCharPr(5, 900, '#5A6660', 1, false, 0)}
      ${this.hwpxCharPr(6, 1000, '#8A4B00', 0, true, -1)}
      ${this.hwpxCharPr(7, 1500, '#003E7E', 0, true, -2)}
    </hh:charProperties>
    <hh:tabProperties itemCnt="1"><hh:tabPr id="0" autoTabLeft="0" autoTabRight="0"/></hh:tabProperties>
    <hh:numberings itemCnt="1">
      <hh:numbering id="1" start="0">
        <hh:paraHead start="1" level="1" align="LEFT" useInstWidth="1" autoIndent="1" widthAdjust="0" textOffsetType="PERCENT" textOffset="50" numFormat="DIGIT" charPrIDRef="4294967295" checkable="0">^1.</hh:paraHead>
      </hh:numbering>
    </hh:numberings>
    <hh:paraProperties itemCnt="8">
      ${this.hwpxParaPr(0, 'JUSTIFY', 165, 0, 0, 0)}
      ${this.hwpxParaPr(1, 'CENTER', 140, 0, 0, 0)}
      ${this.hwpxParaPr(2, 'CENTER', 130, 0, 260, 180)}
      ${this.hwpxParaPr(3, 'LEFT', 150, 0, 300, 120)}
      ${this.hwpxParaPr(4, 'JUSTIFY', 155, 760, 80, 80)}
      ${this.hwpxParaPr(5, 'CENTER', 135, 0, 0, 0)}
      ${this.hwpxParaPr(6, 'JUSTIFY', 140, 0, 0, 0)}
      ${this.hwpxParaPr(7, 'LEFT', 145, 0, 420, 200)}
    </hh:paraProperties>
    <hh:styles itemCnt="1">
      <hh:style id="0" type="PARA" name="바탕글" engName="Normal" paraPrIDRef="0" charPrIDRef="0" nextStyleIDRef="0" langID="1042" lockForm="0"/>
    </hh:styles>
  </hh:refList>
  <hh:compatibleDocument targetProgram="HWP2018"/>
  <hh:docOption/>
</hh:head>`;
    }

    private hwpxFontFaces() {
        const langs = ['HANGUL', 'LATIN', 'HANJA', 'JAPANESE', 'OTHER', 'SYMBOL', 'USER'];
        const faces = langs.map((lang) => `<hh:fontface lang="${lang}" fontCnt="2">
        <hh:font id="0" face="함초롬돋움" type="TTF" isEmbedded="0"><hh:typeInfo familyType="FCAT_GOTHIC" weight="6" proportion="4" contrast="0" strokeVariation="1" armStyle="1" letterform="1" midline="1" xHeight="1"/></hh:font>
        <hh:font id="1" face="함초롬바탕" type="TTF" isEmbedded="0"><hh:typeInfo familyType="FCAT_GOTHIC" weight="6" proportion="4" contrast="0" strokeVariation="1" armStyle="1" letterform="1" midline="1" xHeight="1"/></hh:font>
      </hh:fontface>`).join('\n      ');
        return `<hh:fontfaces itemCnt="7">\n      ${faces}\n    </hh:fontfaces>`;
    }

    private hwpxBorderFill(id: number, type: string, fillColor: string) {
        const fill = fillColor && fillColor !== 'none' ? `\n        <hc:fillBrush><hc:winBrush faceColor="${fillColor}" hatchColor="#999999" alpha="0"/></hc:fillBrush>` : '';
        return `<hh:borderFill id="${id}" threeD="0" shadow="0" centerLine="NONE" breakCellSeparateLine="0">
        <hh:slash type="NONE" Crooked="0" isCounter="0"/>
        <hh:backSlash type="NONE" Crooked="0" isCounter="0"/>
        <hh:leftBorder type="${type}" width="0.12 mm" color="#6F7B75"/>
        <hh:rightBorder type="${type}" width="0.12 mm" color="#6F7B75"/>
        <hh:topBorder type="${type}" width="0.12 mm" color="#6F7B75"/>
        <hh:bottomBorder type="${type}" width="0.12 mm" color="#6F7B75"/>
        <hh:diagonal type="SOLID" width="0.1 mm" color="#6F7B75"/>${fill}
      </hh:borderFill>`;
    }

    private hwpxCharPr(id: number, height: number, color: string, fontRef: number, bold: boolean, spacing: number = 0) {
        return `<hh:charPr id="${id}" height="${height}" textColor="${color}" shadeColor="none" useFontSpace="0" useKerning="0" symMark="NONE" borderFillIDRef="2">
        <hh:fontRef hangul="${fontRef}" latin="${fontRef}" hanja="${fontRef}" japanese="${fontRef}" other="${fontRef}" symbol="${fontRef}" user="${fontRef}"/>
        <hh:ratio hangul="100" latin="100" hanja="100" japanese="100" other="100" symbol="100" user="100"/>
        <hh:spacing hangul="${spacing}" latin="${spacing}" hanja="${spacing}" japanese="${spacing}" other="${spacing}" symbol="${spacing}" user="${spacing}"/>
        <hh:relSz hangul="100" latin="100" hanja="100" japanese="100" other="100" symbol="100" user="100"/>
        <hh:offset hangul="0" latin="0" hanja="0" japanese="0" other="0" symbol="0" user="0"/>
        <hh:underline type="NONE" shape="SOLID" color="#000000"/>
        <hh:strikeout shape="NONE" color="#000000"/>
        <hh:outline type="NONE"/>
        <hh:shadow type="NONE" color="#C0C0C0" offsetX="10" offsetY="10"/>
        ${bold ? '<hh:bold/>' : ''}
      </hh:charPr>`;
    }

    private hwpxParaPr(id: number, align: string, lineSpacing: number, left: number, prev: number, next: number) {
        return `<hh:paraPr id="${id}" tabPrIDRef="0" condense="0" fontLineHeight="0" snapToGrid="1" suppressLineNumbers="0" checked="0" textDir="LTR">
        <hh:align horizontal="${align}" vertical="BASELINE"/>
        <hh:heading type="NONE" idRef="0" level="0"/>
        <hh:breakSetting breakLatinWord="KEEP_WORD" breakNonLatinWord="BREAK_WORD" widowOrphan="0" keepWithNext="0" keepLines="0" pageBreakBefore="0" lineWrap="BREAK"/>
        <hh:autoSpacing eAsianEng="0" eAsianNum="0"/>
        <hp:switch>
          <hp:case hp:required-namespace="http://www.hancom.co.kr/hwpml/2016/HwpUnitChar">
            <hh:margin><hc:intent value="0" unit="HWPUNIT"/><hc:left value="${left}" unit="HWPUNIT"/><hc:right value="0" unit="HWPUNIT"/><hc:prev value="${prev}" unit="HWPUNIT"/><hc:next value="${next}" unit="HWPUNIT"/></hh:margin>
            <hh:lineSpacing type="PERCENT" value="${lineSpacing}" unit="HWPUNIT"/>
          </hp:case>
          <hp:default>
            <hh:margin><hc:intent value="0" unit="HWPUNIT"/><hc:left value="${left}" unit="HWPUNIT"/><hc:right value="0" unit="HWPUNIT"/><hc:prev value="${prev}" unit="HWPUNIT"/><hc:next value="${next}" unit="HWPUNIT"/></hh:margin>
            <hh:lineSpacing type="PERCENT" value="${lineSpacing}" unit="HWPUNIT"/>
          </hp:default>
        </hp:switch>
        <hh:border borderFillIDRef="2" offsetLeft="0" offsetRight="0" offsetTop="0" offsetBottom="0" connect="0" ignoreMargin="0"/>
      </hh:paraPr>`;
    }

    private buildHwpxContentHpf(patrol: any, reportTitle: string) {
        const title = this.xmlText(reportTitle);
        const creator = this.xmlText(`${this.parkReportOrgName()} ${patrol.owner || '자원보전 업무팀'}`);
        const generatedAt = this.xmlText(patrol.generatedAt || this.nowLabel());
        return `<?xml version="1.0" encoding="UTF-8"?>
<opf:package ${this.hwpxNamespaces()} version="" unique-identifier="" id="">
  <opf:metadata>
    <opf:title>${title}</opf:title>
    <opf:language>ko</opf:language>
    <opf:meta name="creator" content="${creator}"/>
    <opf:meta name="subject" content="국립공원공단 속리산국립공원 AI 순찰 결과 보고"/>
    <opf:meta name="description" content="국립공원공단 속리산국립공원사무소 AI 순찰 결과 보고서"/>
    <opf:meta name="lastsaveby" content="${creator}"/>
    <opf:meta name="CreatedDate" content="${generatedAt}"/>
    <opf:meta name="ModifiedDate" content="${generatedAt}"/>
    <opf:meta name="date" content="${generatedAt}"/>
    <opf:meta name="keyword" content="국립공원공단,속리산국립공원,AI순찰,자원보전,보고서,HWPX"/>
  </opf:metadata>
  <opf:manifest>
    <opf:item id="header" href="Contents/header.xml" media-type="application/xml"/>
    <opf:item id="section0" href="Contents/section0.xml" media-type="application/xml"/>
    <opf:item id="settings" href="settings.xml" media-type="application/xml"/>
  </opf:manifest>
  <opf:spine>
    <opf:itemref idref="header" linear="yes"/>
    <opf:itemref idref="section0" linear="yes"/>
  </opf:spine>
</opf:package>`;
    }

    private buildHwpxVersionXml() {
        return `<?xml version="1.0" encoding="UTF-8"?>
<hv:HCFVersion xmlns:hv="http://www.hancom.co.kr/hwpml/2011/version" tagetApplication="WORDPROCESSOR" major="5" minor="1" micro="1" buildNumber="0" os="1" xmlVersion="1.5" application="Hancom Office Hangul" appVersion="13, 0, 0, 0"/>`;
    }

    private buildHwpxSettingsXml() {
        return `<?xml version="1.0" encoding="UTF-8"?>
<config:config-item-set xmlns:config="urn:oasis:names:tc:opendocument:xmlns:config:1.0" config:name="configuration-settings"/>`;
    }

    private buildHwpxContainerXml() {
        return `<?xml version="1.0" encoding="UTF-8"?>
<container version="1.0" xmlns="urn:oasis:names:tc:opendocument:xmlns:container">
  <rootfiles>
    <rootfile full-path="Contents/content.hpf" media-type="application/hwpml-package+xml"/>
  </rootfiles>
</container>`;
    }

    private buildHwpxManifestXml() {
        return `<?xml version="1.0" encoding="UTF-8"?>
<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0">
  <manifest:file-entry manifest:media-type="application/hwp+zip" manifest:full-path="/"/>
  <manifest:file-entry manifest:media-type="application/xml" manifest:full-path="version.xml"/>
  <manifest:file-entry manifest:media-type="application/xml" manifest:full-path="settings.xml"/>
  <manifest:file-entry manifest:media-type="application/xml" manifest:full-path="Contents/content.hpf"/>
  <manifest:file-entry manifest:media-type="application/xml" manifest:full-path="Contents/header.xml"/>
  <manifest:file-entry manifest:media-type="application/xml" manifest:full-path="Contents/section0.xml"/>
  <manifest:file-entry manifest:media-type="text/plain" manifest:full-path="Preview/PrvText.txt"/>
</manifest:manifest>`;
    }

    private hwpxNamespaces() {
        return `xmlns:ha="http://www.hancom.co.kr/hwpml/2011/app" xmlns:hp="http://www.hancom.co.kr/hwpml/2011/paragraph" xmlns:hp10="http://www.hancom.co.kr/hwpml/2016/paragraph" xmlns:hs="http://www.hancom.co.kr/hwpml/2011/section" xmlns:hc="http://www.hancom.co.kr/hwpml/2011/core" xmlns:hh="http://www.hancom.co.kr/hwpml/2011/head" xmlns:hhs="http://www.hancom.co.kr/hwpml/2011/history" xmlns:hm="http://www.hancom.co.kr/hwpml/2011/master-page" xmlns:hpf="http://www.hancom.co.kr/schema/2011/hpf" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:opf="http://www.idpf.org/2007/opf/" xmlns:ooxmlchart="http://www.hancom.co.kr/hwpml/2016/ooxmlchart" xmlns:hwpunitchar="http://www.hancom.co.kr/hwpml/2016/HwpUnitChar" xmlns:epub="http://www.idpf.org/2007/ops" xmlns:config="urn:oasis:names:tc:opendocument:xmlns:config:1.0"`;
    }

    private createStoredZip(files: any[]) {
        const encoder = new TextEncoder();
        const chunks: Uint8Array[] = [];
        const centralChunks: Uint8Array[] = [];
        const mod = this.zipDateTime();
        let offset = 0;

        (files || []).forEach((file) => {
            const nameBytes = encoder.encode(file.path);
            const data = typeof file.content === 'string' ? encoder.encode(file.content) : file.content;
            const crc = this.crc32(data);
            const localHeader = new Uint8Array(30 + nameBytes.length);
            const localView = new DataView(localHeader.buffer);
            localView.setUint32(0, 0x04034b50, true);
            localView.setUint16(4, 20, true);
            localView.setUint16(6, 0x0800, true);
            localView.setUint16(8, 0, true);
            localView.setUint16(10, mod.time, true);
            localView.setUint16(12, mod.date, true);
            localView.setUint32(14, crc, true);
            localView.setUint32(18, data.length, true);
            localView.setUint32(22, data.length, true);
            localView.setUint16(26, nameBytes.length, true);
            localView.setUint16(28, 0, true);
            localHeader.set(nameBytes, 30);
            chunks.push(localHeader, data);

            const centralHeader = new Uint8Array(46 + nameBytes.length);
            const centralView = new DataView(centralHeader.buffer);
            centralView.setUint32(0, 0x02014b50, true);
            centralView.setUint16(4, 20, true);
            centralView.setUint16(6, 20, true);
            centralView.setUint16(8, 0x0800, true);
            centralView.setUint16(10, 0, true);
            centralView.setUint16(12, mod.time, true);
            centralView.setUint16(14, mod.date, true);
            centralView.setUint32(16, crc, true);
            centralView.setUint32(20, data.length, true);
            centralView.setUint32(24, data.length, true);
            centralView.setUint16(28, nameBytes.length, true);
            centralView.setUint16(30, 0, true);
            centralView.setUint16(32, 0, true);
            centralView.setUint16(34, 0, true);
            centralView.setUint16(36, 0, true);
            centralView.setUint32(38, 0, true);
            centralView.setUint32(42, offset, true);
            centralHeader.set(nameBytes, 46);
            centralChunks.push(centralHeader);
            offset += localHeader.length + data.length;
        });

        const centralDirectory = this.concatBytes(centralChunks);
        const endRecord = new Uint8Array(22);
        const endView = new DataView(endRecord.buffer);
        endView.setUint32(0, 0x06054b50, true);
        endView.setUint16(8, files.length, true);
        endView.setUint16(10, files.length, true);
        endView.setUint32(12, centralDirectory.length, true);
        endView.setUint32(16, offset, true);
        endView.setUint16(20, 0, true);
        return this.concatBytes([...chunks, centralDirectory, endRecord]);
    }

    private zipDateTime() {
        const now = new Date();
        const time = (now.getHours() << 11) | (now.getMinutes() << 5) | Math.floor(now.getSeconds() / 2);
        const date = ((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate();
        return { time, date };
    }

    private crc32(bytes: Uint8Array) {
        let crc = 0xffffffff;
        for (let index = 0; index < bytes.length; index += 1) {
            crc ^= bytes[index];
            for (let bit = 0; bit < 8; bit += 1) {
                crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1));
            }
        }
        return (crc ^ 0xffffffff) >>> 0;
    }

    private concatBytes(chunks: Uint8Array[]) {
        const total = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
        const output = new Uint8Array(total);
        let offset = 0;
        chunks.forEach((chunk) => {
            output.set(chunk, offset);
            offset += chunk.length;
        });
        return output;
    }

    private downloadBytes(bytes: Uint8Array, fileName: string, contentType: string) {
        const blob = new Blob([bytes], { type: contentType });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    private safeFileName(value: string) {
        return String(value || 'report.hwpx')
            .replace(/[\\/:*?"<>|]+/g, '_')
            .replace(/\s+/g, '_');
    }

    private xmlText(value: any) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&apos;');
    }

    private reportCodeFor(patrol: any) {
        const seed = String(patrol.missionCode || patrol.code || 'OPS').replace(/[^0-9a-zA-Z가-힣]/g, '') || 'OPS';
        return `RPT-${this.monthLabel().replace('-', '')}-${seed.slice(-10)}`;
    }

    private dateValue(value: any) {
        const date = new Date(value || '');
        return isNaN(date.getTime()) ? 0 : date.getTime();
    }

    private storageDateKey() {
        return this.todayLabel();
    }

    private completionStorageKey() {
        return `songnisan.missions.completed.${this.storageDateKey()}`;
    }

    private completedMissionMap() {
        try {
            return JSON.parse(localStorage.getItem(this.completionStorageKey()) || '{}') || {};
        } catch (error) {
            return {};
        }
    }

    private reportStorageKey() {
        return `songnisan.reports.generated.${this.storageDateKey()}`;
    }

    private savedReportMap() {
        try {
            return JSON.parse(localStorage.getItem(this.reportStorageKey()) || '{}') || {};
        } catch (error) {
            return {};
        }
    }

    private rememberReport(patrol: any) {
        if (!patrol || !patrol.code) return;
        try {
            const map = this.savedReportMap();
            map[patrol.code] = {
                reportCode: patrol.reportCode,
                reportStatus: patrol.reportStatus,
                generatedAt: patrol.generatedAt
            };
            localStorage.setItem(this.reportStorageKey(), JSON.stringify(map));
            this.generatedReportMap = map;
        } catch (error) { }
    }
}

export default PageReportsComponent;